import { Graph } from "src/api/flowTypes";
import { GraphTransform } from "src/utils/GraphUtils";
import { isCustomConnectionNode } from "src/utils/predicates";

export type CustomConnectionNodeData = {
  nodeLabel: string;
  connectionId: string;
};

export const extractCustomConnectionNodeData = (
  graph: Graph | undefined,
): CustomConnectionNodeData | null => {
  if (!graph?.nodes) return null;

  const mappedNodes = graph.nodes.map(GraphTransform.nodeMapper);
  const customNode = mappedNodes.find(isCustomConnectionNode);
  if (!customNode?.data) return null;

  return {
    nodeLabel: customNode.data.label,
    connectionId: customNode.data.connectionId,
  };
};
